import React, { useState, useEffect } from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, c as _slicedToArray, b as _extends } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import './head-b3f271d9.js';
import './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import { Header3 } from './Typographies.js';
import './index-f96168ba.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: transparent;\n  box-shadow: none;\n  border: 0;\n  &:hover {\n    cursor: pointer;\n  }\n  svg {\n    path:first-child {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var CloseButton = styled('button')(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.components.modal.colors.closeButton;
});

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  overflow: auto;\n  max-height: 70vh;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var ContentContainer = styled('aside')(_templateObject$1(), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.components.modal.spaces.paddingHeightContent, " ").concat(theme.components.modal.spaces.paddingWidthContent);
});

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  content: ' ';\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  z-index: 50;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var ModalBackground = styled('div')(_templateObject$2(), function (_ref) {
  var theme = _ref.theme;
  return theme.components.modal.colors.overlayBackground;
});

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  z-index: 51;\n  position: fixed;\n  width: 80%;\n  height: auto;\n  max-height: 90vh;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  ", "\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var ModalContainer = styled('div')(_templateObject$3(), function (_ref) {
  var theme = _ref.theme;
  return "\n    background: ".concat(theme.components.modal.colors.background, ";\n    box-shadow: ").concat(theme.components.modal.boxShadows.boxShadow, ";\n    border-radius: ").concat(theme.components.modal.borders.radius, ";\n  ");
});

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var TitleContainer = styled('div')(_templateObject$4(), function (_ref) {
  var theme = _ref.theme;
  return "\n    padding: ".concat(theme.components.modal.spaces.paddingHeightContent, " ").concat(theme.components.modal.spaces.paddingWidthContent, ";\n    border-bottom: ").concat(theme.components.modal.borders.titleBottomWidth, " solid ").concat(theme.components.modal.borders.titleBottomColor, ";\n  ");
});

function _templateObject$5() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A Modal.
 *
 */

var Modal = function Modal(_ref) {
  var children = _ref.children,
      isOpened = _ref.isOpened,
      onClose = _ref.onClose,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["children", "isOpened", "onClose", "title"]);

  var _useState = useState(isOpened),
      _useState2 = _slicedToArray(_useState, 2),
      opened = _useState2[0],
      setOpened = _useState2[1];

  useEffect(function () {
    setOpened(isOpened);
  }, [isOpened]);

  var closeModal = function closeModal() {
    onClose && onClose();
    setOpened(false);
  };

  return opened && React.createElement(ModalBackground, _extends({
    onClick: closeModal
  }, rest), React.createElement(ModalContainer, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, React.createElement(TitleContainer, null, React.createElement(Header3, null, title), React.createElement(CloseButton, {
    type: "button",
    onClick: closeModal,
    "aria-label": "Close Modal"
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })))), children && React.createElement(ContentContainer, null, children)));
};

Modal.defaultProps = {
  children: '',
  isOpened: false,
  onClose: null
};
Modal.propTypes = {
  /**
   * The content of the Modal.
   */
  children: PropTypes.any,

  /**
   * Is the modal opened or not.
   */
  isOpened: PropTypes.bool,

  /**
   * Function executed when the Modal is closed.
   */
  onClose: PropTypes.func,

  /**
   * The title of the Modal.
   */
  title: PropTypes.string.isRequired
};
/** @component */

var index = styled(Modal)(_templateObject$5());

export default index;
